// extracted by mini-css-extract-plugin
module.exports = {"block":"index_block_1UhRH"};